import * as THREE from "three";
import React, { useRef } from "react";
import { useThree, useFrame } from "react-three-fiber";
import useStore from "../store";

const MOVE_SPEED = 0.05;
const playerWorldPos = new THREE.Vector3();
const forwardWorldPos = new THREE.Vector3();
const cameraTargetVector = new THREE.Vector3(0, 1, 0);
const temp = new THREE.Vector3();
const origin = new THREE.Vector3(0, 0, 0);
const vectorStart = new THREE.Vector3();
const vectorEnd = new THREE.Vector3();
const raycaster = new THREE.Raycaster();
let angle = null;
let intersects = [];

const PlayerFollowBehindControls = (props) => {
  const { player, globe } = props;

  const { camera } = useThree();
  const controls = useStore((state) => state.controls);
  const debug = useStore((state) => state.debug);
  const { setPlayerWorldPosition } = useStore(state => state.actions);
  
  
  const cameraPos = useRef();
  const forward = useRef();
  
  useFrame(() => {
    // CODE FOR UPDATING PLAYER POS
    // TODO: change up / down to a single vertical speed number
    const deltaRotationY = controls.right ? -MOVE_SPEED : controls.left ? MOVE_SPEED : 0;

    player.current.rotateY(deltaRotationY);
    player.current.getWorldPosition(playerWorldPos);
    setPlayerWorldPosition(playerWorldPos);

    vectorStart.copy(playerWorldPos);
    forward.current.getWorldPosition(forwardWorldPos);

    raycaster.set(origin, forwardWorldPos.normalize());
    intersects = [];
    raycaster.intersectObject(globe.current, true, intersects);

    if (debug.logging) {
      console.log(intersects);
    }

    if (controls.up) {
      vectorEnd.copy(forwardWorldPos);

      angle = vectorStart.normalize().angleTo(vectorEnd.normalize());

      player.current.rotateX(angle);
      player.current.position.copy(intersects[0].point);
    }

    // CODE FOR UPDATING CAMERA
    if (camera && cameraPos.current) {
      // code for following the player with the camera from a variable angle
      if (!debug.orbitControls) {
        if (cameraPos.current) {
          const mat = cameraPos.current.matrixWorld;
          temp.setFromMatrixPosition(mat);
          camera.position.lerp(temp, 0.2);
          camera.lookAt(playerWorldPos.add(cameraTargetVector));
    
          camera.up.copy(temp.normalize());
        }
      }
    }
  })

  if (!player.current || !globe.current) return null;;

  return (
    <>
      { debug.arrows && ["red", "green", "blue", "purple"].map((color, i) => {
        let x = 0,
          z = 0;
        switch (i) {
          case 0:
            z = MOVE_SPEED;
            break;
          case 1:
            x = -MOVE_SPEED;
            break;
          case 2:
            z = -MOVE_SPEED;
            break;
          case 3:
            x = MOVE_SPEED;
            break;
          default:
            break;
        }

        return (
          <mesh key={i} position={[x * 20, -1, z * 20]}>
            <boxBufferGeometry attach="geometry" args={[0.2, 0.2, 0.2]} />
            <meshBasicMaterial attach="material" color={color} />
          </mesh>
        );
      })}
      <object3D position={[0, 0, MOVE_SPEED]} ref={forward} />
      <object3D position={[0, 0, -2]} ref={cameraPos} />
    </>
  );
};

export default PlayerFollowBehindControls;